module.exports = {
  apiHost: "https://api.vantageharmony.sensoreal.com.au",
  assetsHost: "https://assets.vantageharmony.sensoreal.com.au",
  brandName: "Vantage Harmony",
  header: {
    text: { en: "Your Vantage Harmony Selections" },
    logo: "",
    companyLogo: "",
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    primaryColor: "#2f4b5b",
    textColor: "#fff",
    font: "Interstate",
  },
  contact: {
    website: "https://avid.com.au/communities/residential/vantage-harmony/",
    address: "22 Twilight Ave, Palmview QLD 4553",
    phone: "1800 826 002",
    email: "",
  },
  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "https://www.instagram.com/avid_together/",
    facebook: "https://www.facebook.com/vantagebyAVID",
  },
  footerLogo:
    "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/avid-edm/general/AVID_White_72dpi.png",
};
